import renderDetails from 'core/controllerPlans/renderDetails'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import textContent from 'utils/DOM/textContent'
import moneyFormat from 'utils/format/money'
import setTooltips from './utils/setTooltips'
import handleAddonClasses from './utils/handleAddonClasses'

const asMoney = moneyFormat

function updateDOM(state) {
  const {
    planId,
    plans,
    dentalPlanId,
    latitudeId,
    supplementalId,
    visionPlanId,
    hasDentalActive
  } = state

  updateAddons({ ...state, addonsByPlan: { [planId]: state.addOns } })
  setTooltips(state)
  textContent('.js-prices-total-without-fee', asMoney(state.plans[state.planId].cost))

  handleAddonClasses({
    plans,
    dentalPlanId,
    latitudeId,
    supplementalId,
    visionPlanId,
    hasDentalActive
  })

  renderDetails(state)
}

export default updateDOM
